import { Routes } from '@angular/router'
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront'
import { RequestServiceQuoteComponent } from '../features/request-service-quote/request-service-quote.component'
import { PlpHomepageComponent } from '../features/plp/plp-homepage/plp-homepage.component'
import { SsoRedirectComponent } from '../features/user/sso-redirect/sso-redirect.component'
import { CustomAuthGuard } from '../shared/util/auth.guard'
import { ViewCartComponent } from '../features/quote/quote-cart/view-cart/view-cart.component'
import { MyProfileComponent } from '../features/user/my-profile/my-profile/my-profile.component'
import { QuoteCheckoutComponent } from '../features/quote/quote-checkout/components/quote-checkout/quote-checkout.component'
import { QuoteReviewComponent } from '../features/quote/quote-review/components/quote-review/quote-review.component'
import { UserManagementComponent } from '../features/user/user-management/user-management.component'
import { CheckoutComponent } from '../features/cart/checkout/checkout/checkout.component'
import { OrderReviewComponent } from '../features/cart/checkout/checkout/order-review/order-review.component'
import { CartDetailsComponent } from '../features/cart/cart-details/cart-details.component'
import { SavedCartComponent } from '../features/cart/saved-cart/saved-cart.component'
import { QuoteConfirmationComponent } from '../features/quote/quote-confirmation/quote-confirmation/quote-confirmation.component'
import { SavedCartDetailComponent } from '../features/cart/saved-cart/saved-cart-detail/saved-cart-detail.component'
import { SearchBySerialComponent } from '../features/welcome-package/search-by-serial/search-by-serial.component'
import { MyFavouritesListComponent } from '../features/my-favourites/my-favourites-list/my-favourites-list.component'
import { EquipmentDetailsComponent } from '../features/welcome-package/search-by-serial/equipment-details/equipment-details.component'
import { QuoteListComponent } from '../features/quote/quote-tracking/quote-list/quote-list.component'
import { QuoteDetailsComponent } from '../features/quote/quote-tracking/quote-details/quote-details.component'
import { OrderTrackingDetailComponent } from '../features/order-tracking/order-tracking-detail/order-tracking-detail.component'
import { OrderConfirmationComponent } from '../features/cart/checkout/checkout/order-confirmation/order-confirmation.component'
import { OrderTrackingListComponent } from '../features/order-tracking/order-tracking-list/order-tracking-list.component'
import { MergeQuoteComponent } from '../features/quote/quote-tracking/quote-merge/merge-quote/merge-quote.component'
import { MergeQuoteAcceptanceComponent } from '../features/quote/quote-tracking/quote-merge/merge-quote-acceptance/merge-quote-acceptance.component'
import { LandingPagesComponent } from '../features/landing-pages/landing-pages.component'
import { OrderTrackingGuestComponent } from '../features/guest-tracking/order-tracking-guest/order-tracking-guest.component'
import { QuoteTrackingGuestComponent } from '../features/guest-tracking/quote-tracking-guest/quote-tracking-guest.component'
import { FeedbackFormComponent } from '../features/help/feedback/feedback-form/feedback-form.component'
import { BulkUploadComponent } from '../features/bulk-order/bulk-upload/bulk-upload.component'
import { BulkTableComponent } from '../features/bulk-order/bulk-table/bulk-table.component'
import { BulkQuoteConfirmationComponent } from '../features/bulk-order/bulk-quote-confirmation/bulk-quote-confirmation.component'
import { BulkOrderConfirmationComponent } from '../features/bulk-order/bulk-order-confirmation/bulk-order-confirmation.component'
import { ContactusComponent } from '../features/contactus/contactus/contactus.component'
import { CheckPriceAvailabilityComponent } from '../features/landing-pages/loggedin-home-page/check-price-availability/check-price-availability.component'
import { CustomLoginGuard } from '../shared/util/login.guard'
import { AccessDeniedComponent } from '../features/user/access-denied/access-denied.component'
import { UserRoleGuard } from '../shared/util/user-role.guard'
import { PageNotFoundComponent } from '../features/page-not-found/page-not-found.component'
import { VlmGuard } from '../shared/vlm.guard'
import { FaqPageComponent } from '../features/faq-page/faq-page.component';

/**
 * Demonstrates static routes and CMS based routes.
 */
export const staticRoutes: Routes = [
  {
    path: 'quote/cart',
    component: ViewCartComponent,
    data: { pageLabel: '/rfqCart' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'quote/checkout',
    component: QuoteCheckoutComponent,
    data: { pageLabel: '/quotecheckout' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'quote/review',
    component: QuoteReviewComponent,
    data: { pageLabel: '/quotereview' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'quote/service',
    redirectTo: '/homepage',
  },
  {
    // path: 'vsCategories/:categoryId',
    path: 'categories/:categoryCode',
    component: PlpHomepageComponent,
    data: { pageLabel: '/vsCategories' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'sso-redirect',
    component: SsoRedirectComponent,
    // data: { pageLabel: '/homepage' },
    canActivate: [CmsPageGuard, CustomAuthGuard],
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    data: { pageLabel: '/homepage' },
    canActivate: [CmsPageGuard],
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    data: { pageLabel: '/homepage' },
    canActivate: [CmsPageGuard],
  },
  {
    path: 'my-profile',
    component: MyProfileComponent,
    data: { pageLabel: '/my-profile' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'spa_redirect',
    component: SsoRedirectComponent,
    data: { pageLabel: '/homepage' },
    canActivate: [CmsPageGuard, CustomAuthGuard],
  },
  {
    path: 'manage-users/users',
    component: UserManagementComponent,
    data: { pageLabel: '/manage-users/users' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    // path: 'cartCheckout',
    path: 'cart/checkout',
    component: CheckoutComponent,
    data: { pageLabel: '/cartCheckout' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },

  {
    // path: 'cartReview',
    path: 'cart/review',
    component: OrderReviewComponent,
    data: { pageLabel: '/cartReview' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  // {
  //   path: 'manage-users/:uid',
  //   component: SampleComponent,
  //   data: { pageLabel: '/manage-users/:uid' },
  //   canActivate: [CmsPageGuard],
  // },
  {
    path: 'cart',
    component: CartDetailsComponent,
    data: { pageLabel: '/cart' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'saved-carts/:savedCartId',
    component: SavedCartDetailComponent,
    data: { pageLabel: '/saved-carts' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'saved-carts',
    component: SavedCartComponent,
    data: { pageLabel: '/saved-carts' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    // path: 'quote-confirmation',
    path: 'quote/confirmation',
    component: QuoteConfirmationComponent,
    data: { pageLabel: '/quoteConfirmation' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  // {
  //   path: 'cart',
  //   component: CartDetailsComponent,
  //   data: { pageLabel: '/cart' },
  //   canActivate: [CmsPageGuard],
  // },
  {
    path: 'welcome-package/serial-search',
    component: SearchBySerialComponent,
    data: { pageLabel: 'welcomepackage/slnoSearch' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'welcome-package/serial-search/:id',
    component: SearchBySerialComponent,
    data: { pageLabel: 'welcomepackage/slnoSearch' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'welcome-package/bom/:id/:recSource',
    component: EquipmentDetailsComponent,
    data: { pageLabel: 'welcomepackage/bomDetails' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'welcome-package/bom/:id',
    component: EquipmentDetailsComponent,
    data: { pageLabel: 'welcomepackage/bomDetails' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'quote-list',
    component: QuoteListComponent,
    data: { pageLabel: 'quotelisting' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'quote-detail/:id',
    component: QuoteDetailsComponent,
    data: { pageLabel: 'quoteTrackingDetails' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'my-account/wishlist',
    component: MyFavouritesListComponent,
    data: { pageLabel: '/my-account/wishlist' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'order-detail/detail/:orderid',
    component: OrderTrackingDetailComponent,
    data: { pageLabel: 'order-detail' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'order-history',
    component: OrderTrackingListComponent,
    data: { pageLabel: 'order-history' },
    canActivate: [CmsPageGuard,CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'order-confirmation',
    component: OrderConfirmationComponent,
    data: { pageLabel: '/order-confirmation' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'quote-merge',
    component: MergeQuoteComponent,
    data: { pageLabel: '/quotelisting' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'quote-acceptance/:quoteId',
    component: MergeQuoteAcceptanceComponent,
    data: { pageLabel: '/quotelisting' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'home',
    component: LandingPagesComponent,
    data: { pageLabel: '/homepage' },
    canActivate: [CmsPageGuard],
  },
  {
    path: 'homepage',
    component: LandingPagesComponent,
    data: { pageLabel: '/homepage' },
    canActivate: [CmsPageGuard],
  },
  {
    path: '',
    component: LandingPagesComponent,
    data: { pageLabel: '/homepage' },
    canActivate: [CmsPageGuard],
  },
  {
    path: 'bulk-from-vlm/:content',
    component: BulkTableComponent,
    data: { pageLabel: '/bulk-Order' },
    canActivate: [CmsPageGuard, UserRoleGuard, VlmGuard],
  },
  {
    path: 'order-status',
    component: OrderTrackingGuestComponent,
    data: { pageLabel: '/order-status' },
    canActivate: [CmsPageGuard],
  },
  {
    path: 'feedback',
    component: FeedbackFormComponent,
    data: { pageLabel: '/feedback' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'bulk-Order',
    component: BulkUploadComponent,
    data: { pageLabel: '/bulk-Order' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'bulk-Table',
    component: BulkTableComponent,
    data: { pageLabel: '/bulk-Order' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'bulk-Quote-Confirm',
    component: BulkQuoteConfirmationComponent,
    data: { pageLabel: '/bulk-Order' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'bulk-Order-Confirm',
    component: BulkOrderConfirmationComponent,
    data: { pageLabel: '/bulk-Order' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'contactus',
    component: ContactusComponent,
    data: { pageLabel: '/contactus' },
    canActivate: [CmsPageGuard, UserRoleGuard],
  },
  {
    path: 'check-price-availability',
    component: CheckPriceAvailabilityComponent,
    data: { pageLabel: '/checkAvailability' },
    canActivate: [CmsPageGuard, CustomLoginGuard, UserRoleGuard],
  },
  {
    path: 'faq',
    component: FaqPageComponent,
    data: { pageLabel: '/faq' },
    canActivate: [CmsPageGuard],
  },
]
